import { useAuthStore } from "../store/auth"

export default {
  install: ({ config }) => {
    config.globalProperties.$auth = useAuthStore()   
  },
};